import { Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';

export const VendorNameCell = (props: ICellRendererParams) => {
  const data = getAgGridTableCellData(props, 'vendorName');
  if (!data) {
    return props?.value;
  }

  const { vendorApNumber } = data;
  // Older quotes predate the stored vendor location name, so fall back to the vendor group name.
  const vendorName = data.vendorLocationName || data.vendorName;
  if (!vendorName && !vendorApNumber) {
    return <TextLine text={DEFAULT_PLACEHOLDER} />;
  }

  return (
    <Stack>
      {vendorName && <TextLine text={vendorName} />}
      {vendorApNumber && <TextLine text={vendorApNumber} isSubText />}
    </Stack>
  );
};
